let takeover;
let takeoverImg;
let takeoverClose;
let takeoverLink;
let $window;
let takeoverCookie;
const cookies = document.cookie;

function takeoverAd() {
  if (typeof window.Cookiebot !== 'undefined' && !window.Cookiebot.consent.preferences) {
    return;
  }

  takeoverCookie = window.fpgmedia_js_params.home + '_cookie_takeover_accept=1';

  if (cookies.indexOf(takeoverCookie) > -1 ) {
    return;
  }

  takeover = $('.Takeover-ad');
  if (!takeover.length) {
    return;
  }

  takeoverClose = $('.Takeover-ad__close');
  takeoverLink = $('.Takeover-ad__link');
  $window = $(window);

  takeover.show();
  setImageHeight();
  takeoverLink.on('click', setCookie);
  takeoverClose.on('click', takeoverAdClose);
  takeoverImg = $('.Takeover-ad__image img').on('load', setImageHeight);
  $window.on('resize', setImageHeight);
}

function setImageHeight() {
  takeoverImg = $('.Takeover-ad__image img:visible');
  takeoverImg.removeAttr('style');
  takeover.removeClass('Takeover-ad--cropped-image');
  takeover.css('height', `${$window.height()}px`);
  const headerHeight = $('.Takeover-ad__header').outerHeight();
  const footerHeight = $('.Takeover-ad__footer').outerHeight();
  const paneAspectRatio = $window.width() / ($window.height() - headerHeight - footerHeight);
  const imageAspectRatio = takeoverImg.width() / takeoverImg.height();
  if (paneAspectRatio > imageAspectRatio) {
    takeoverImg.css('height', `${$window.height() - headerHeight - footerHeight}px`).css('width', 'auto');
    // If there is very little room for the image: crop id
    if (takeoverImg.width() < $window.width() * 0.67 && $window.width() > $window.height()) {
      takeoverImg.removeAttr('style');
      takeover.addClass('Takeover-ad--croped-image');
    }
  } else {
    takeoverImg.css('width', `${$window.width()}px`).css('height', 'auto');
  }
}

function takeoverAdClose() {
  takeover.css('display', 'none');

  setCookie();
}

function setCookie () {
  var today = new Date();
  var expire = new Date();
  expire.setTime(today.getTime() + 3*24*60*60*1000);
  document.cookie = takeoverCookie +'=' + ';expires='+ expire.toGMTString() + ';path=/';
}

export default function() {
  takeoverAd();
  $(window).on('fpgmedia:post_loaded', takeoverAd);
}



// WEBPACK FOOTER //
// ./scripts/components/takeover-ad.js